import { render, staticRenderFns } from "./ModalRegistUserAcademy.vue?vue&type=template&id=67152bad&scoped=true&lang=pug&"
import script from "./ModalRegistUserAcademy.vue?vue&type=script&lang=ts&"
export * from "./ModalRegistUserAcademy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67152bad",
  null
  
)

export default component.exports